import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

// Store
import { PolicySelectors, PolicySummarySelectors } from '@amfam/policy/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { LoadingSpinnerService } from '@amfam/ui-kit';

@Injectable()
export class NewDocumentGuard {
  constructor(
    private store: Store<any>,
    private spinner: LoadingSpinnerService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.spinner.start();
    return combineLatest(
      this.store.select(PolicySelectors.selectPoliciesLoading),
      this.store.select(PolicySummarySelectors.selectPolicySummaryLoading),
      this.store.select(PolicySelectors.selectPolicyRisks),
      (policiesLoading, policySummaryLoading, policies) => ({
        loading: policiesLoading || policySummaryLoading,

        policies: policies
      })
    ).pipe(
      filter(state => !state.loading && !!_get(state, 'policies.length')),
      switchMap(state => {
        const matchedPolicy = state.policies.find(policy =>
          policy.policyNumber.includes(route.params['id'])
        );
        this.spinner.stop();
        if (matchedPolicy) {
          const policyType = (
            matchedPolicy.policyTypeName === 'Home' ? 'property' : matchedPolicy.policyTypeName
          ).toLowerCase();

          this.store.dispatch(
            fromRouterActions.Go({
              path: [`policies/${policyType}/${matchedPolicy.policyNumber}`],
              query: { openAccordion: 'documents', tid: 'newdocnotice' }
            })
          );
          return of(true);
        } else {
          this.store.dispatch(
            fromRouterActions.Go({
              path: [`overview`]
            })
          );
          return of(false);
        }
      })
    );
  }
}
